import React from "react";
import { useStrings } from "../../hooks/useStrings";

interface SignOutSuccessProps {
  visitDuration: string;
  visitorName: string;
  orgName: string;
}

const SignOutSuccess: React.FC<SignOutSuccessProps> = ({
  visitDuration,
  visitorName,
  orgName,
}) => {
  const S = useStrings();
  return (
  <div className="signout-success-screen">
    <div className="success-checkmark">
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
        <circle cx="32" cy="32" r="32" fill="#dcfce7" />
        <circle cx="32" cy="32" r="24" fill="#bbf7d0" />
        <path
          d="M21 32l8 8 14-16"
          stroke="#16a34a"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>

    <div className="success-text">
      <h1>{S.SIGN_OUT.SUCCESS_TITLE}</h1>
      <p>
        {S.SIGN_OUT.SUCCESS_SUBTITLE}
        {orgName ? ` ${orgName}` : ""}
        {visitorName ? `, ${visitorName}` : ""}. {S.SIGN_OUT.SUCCESS_CLOSING}
      </p>
    </div>

    {visitDuration && (
      <div className="success-duration-card">
        <div className="success-duration-icon">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <circle cx="9" cy="9" r="7" stroke="#6b7280" strokeWidth="1.4" />
            <path
              d="M9 5.5V9.5l2.5 2.5"
              stroke="#6b7280"
              strokeWidth="1.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="success-duration-text">
          <span className="duration-label">
            {S.SIGN_OUT.LABEL_VISIT_DURATION}
          </span>
          <span className="duration-value">{visitDuration}</span>
        </div>
      </div>
    )}

  </div>
  );
};

export default SignOutSuccess;
